module.exports = __webpack_public_path__ + "static/img/page_02.409ba89.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page_02.jpeg
// module id = rsAs
// module chunks = 0